import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { WayToPayEnums } from 'src/app/enum/way-to-pay.enums';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { CashReceiptPaymentPrintModel } from 'src/app/models/print/wallet/cash-receipt-payment-print.model';
import { CashReceiptPrintModel } from 'src/app/models/print/wallet/cash-receipt-print.model';
import { FormatDetailService } from 'src/app/services/formats/format-detail.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';

@Component({
  selector: 'app-print-cash-receipt',
  templateUrl: './print-cash-receipt.component.html',
  styleUrls: ['./print-cash-receipt.component.scss'],
  standalone: false
})
export class PrintCashReceiptComponent implements OnChanges, OnDestroy {

  @Input() cashReceiptModels: Array<CashReceiptPrintModel> = new Array<CashReceiptPrintModel>();
  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() exportFormat: boolean = false;
  @Input() focusText: boolean = false;
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrint = new EventEmitter<boolean>();

  bottomPreview: number = 0;
  cashReceiptId: number = 0;
  codeAdvance: number = WayToPayEnums.anticipos;
  columns: { field: string; header: string; }[] = [];
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'document': { id: 'documento', type: 'text', showTotal: false, printFormat: null },
    'totalValue': { id: 'valor-total', type: 'decimal', showTotal: true, printFormat: null },
    'reteFuenteValue': { id: 'retefuente', type: 'decimal', showTotal: true, printFormat: null },
    'reteIvaValue': { id: 'reteiva', type: 'decimal', showTotal: true, printFormat: null },
    'reteIcaValue': { id: 'reteica', type: 'decimal', showTotal: true, printFormat: null },
    'otherTaxes': { id: 'otros-impuestos', type: 'decimal', showTotal: true, printFormat: null },
    'discountValue': { id: 'descuento', type: 'decimal', showTotal: true, printFormat: null },
    'paidValue': { id: 'valor-pagado', type: 'decimal', showTotal: true, printFormat: null },
  };
  columnsWayToPay: { field: string; header: string; }[] = [];
  idMapWayToPay: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'codeWayToPay': { id: 'codigo-forma-pago', type: 'text', showTotal: false, printFormat: null },
    'descriptionWayToPay': { id: 'descripcion-forma-pago', type: 'text', showTotal: false, printFormat: null },
    'paidValueWayToPay': { id: 'vr-pagado-forma-pago', type: 'decimal', showTotal: true, printFormat: null },
  };
  dateNow: Date = new Date();
  element: any;
  elementsBody: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementsBody2: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementsLabel: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementStyle: any;
  formatModel: FormatModel = new FormatModel();
  id = '';
  invoiceObservation: string | null = null;
  isShift = false;
  leftPreview: number = 0;
  listFormatDetailUpdates: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  logoEnterprise: SafeUrl = "";
  logoFooterEnterprise: SafeUrl = "";
  mouseDown: boolean = false;
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  rightPreview: number = 0;
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  topPreview: number = 0;
  thDescripcion: string = "";
  thDescuento: string = "";
  thDocumento: string = "";
  thFormaPago: string = "";
  thOtrosImpuestos: string = "";
  thReteFuente: string = "";
  thReteIca: string = "";
  thReteIva: string = "";
  thValorPagado: string = "";
  thValor: string = "";
  thValorTotal: string = "";
  version: string = ProjectVersion.projectVersion;

  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  constructor(private cdr: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private formatDetailService: FormatDetailService,
    private formatService: FormatService,
    private sanitizer: DomSanitizer,
    private printPageSizeService: PrintPageSizeService
  ) { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const exportFormat = changes["exportFormat"];
    const formatDetail = changes["formatDetail"];
    const cashReceiptModels = changes["cashReceiptModels"];

    if (cashReceiptModels && !cashReceiptModels.firstChange) {
      if (this.cashReceiptModels[0].enterpriseLogo != null) {
        this.listFormatDetailUpdates = new Array<FormatDetailModel>();
        await this.getLogo(this.cashReceiptModels[0].enterpriseLogo);
      } else {
        this.getLogoDefault();
      }
      this.getPrintCashReceipts();
    }

    if (exportFormat && !exportFormat.firstChange) this.updateRangeFormatDetail();
    if (formatDetail && !formatDetail.firstChange) this.changeFormatDetail();
  }

  ngOnDestroy() {
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) {
      return;
    }
    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));
    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;
    this.onClick();
  }

  private async applyColumnStyles(cashReceiptPrintModel: CashReceiptPrintModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find(x => x.description === column);
      if (!element) {
        continue;
      }
      this.element = document.getElementById(`${element.name}-${cashReceiptPrintModel.cashReceiptId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }
    }

    for (const column of this.columnsWayToPay.map(x => x.field)) {
      const element = this.elementsBody2.find(x => x.description === column);
      if (!element) {
        continue;
      }
      this.element = document.getElementById(`${element.name}-${cashReceiptPrintModel.cashReceiptId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }
    }
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private applyFormatDetails(elements: FormatDetailModel[], cashReceiptPrintModel: CashReceiptPrintModel) {
    for (const element of elements) {
      if (element.band === 'body' || element.band === 'body2') {
        continue;
      }
      setTimeout(async () => {
        this.element = document.getElementById(`${element.name}-${cashReceiptPrintModel.cashReceiptId}`);
        if (this.element) {
          this.applyElementStyles(element);
        }
      }, 200);

      setTimeout(() => {
        //Cargo los encabezados del detalle:
        this.columns.forEach(column => {
          const element = this.elementsBody.find(x => x.description === column.field);
          this.element = document.getElementById(`${element!.name}-${this.cashReceiptModels[0].cashReceiptId}`);
          if (this.element) {
            this.element.style.fontSize = `${element!.fontSize}px`;
            this.element.style.width = `${element!.width}%`;
            this.changeAlignment(element!.alignment);
          }
        });
        this.dateNow = new Date();
      }, 200);

      setTimeout(() => {
        //Cargo los encabezados del detalle 2:
        this.columnsWayToPay.forEach(column => {
          const element = this.elementsBody2.find(x => x.description === column.field);
          this.element = document.getElementById(`${element!.name}-${this.cashReceiptModels[0].cashReceiptId}`);
          if (this.element) {
            this.element.style.fontSize = `${element!.fontSize}px`;
            this.element.style.width = `${element!.width}%`;
            this.changeAlignment(element!.alignment);
          }
        });
        this.dateNow = new Date();
      }, 200);
    }
  }

  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);

    if (!this.formatDetail.name.includes('foot-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }

    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private applyHeaderFooterHeights(cashReceiptId: number, formatModel: FormatModel) {
    setTimeout(async () => {
      const head = document.getElementById(`head-${cashReceiptId}`);
      head!.style.height = `${formatModel.head}px`;
      const foot = document.getElementById(`foot-${cashReceiptId}`);
      foot!.style.height = `${formatModel.foot}px`;
    }, 200);
  }

  private applyParagraphStyles(cashReceiptPrintModel: CashReceiptPrintModel) {
    this.elementsBody.filter(x => x.type === 'p').forEach(element => {
      cashReceiptPrintModel.invoiceCashReceipts!.forEach(detail => {
        const id = element.name.includes("footer") ? detail.cashReceiptId : detail.invoiceCashReceiptId;
        this.element = document.getElementById(`${element.name}-${id}`);
        if (this.element) {
          this.element.style.fontSize = `${element.fontSize}px`;
          this.changeAlignment(element.alignment);
          this.changeBold(element.bold);
        }
      });
    });
    this.elementsBody2.filter(x => x.type === 'p').forEach(element => {
      cashReceiptPrintModel.cashReceiptPayments.forEach(detail => {
        const id = element.name.includes("footer") ? detail.cashReceiptId : detail.cashReceiptPaymentId;
        this.element = document.getElementById(`${element.name}-${id}`);
        if (this.element) {
          this.element.style.fontSize = `${element.fontSize}px`;
          this.changeAlignment(element.alignment);
          this.changeBold(element.bold);
        }
      });
    });
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  private buildDisplayedColumns() {
    this.columns = [];
    this.columnsWayToPay = [];
    this.elementsBody.filter(x => x.type === 'label').forEach(element => {
      this.columns.push({ field: element.description!, header: element.text! });
      this.idMap[element.description!].printFormat = element.printFormat ?? null;
    });
    this.elementsBody2.filter(x => x.type === 'label').forEach(element => {
      this.columnsWayToPay.push({ field: element.description!, header: element.text! });
      this.idMapWayToPay[element.description!].printFormat = element.printFormat ?? null;
    });
  }

  changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  changeFormatDetail() {
    const formatDetailId = this.formatDetail.formatDetailId;
    const isBody = this.formatDetail.band === 'body';
    const isBody2 = this.formatDetail.band === 'body2';
    const isLabel = this.formatDetail.type === 'label';

    if (isBody) {
      const element = this.elementsBody.find(x => x.formatDetailId === formatDetailId);
      if (!element) {
        return;
      }

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;
      element.printFormat = this.formatDetail.printFormat;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;

        if (!this.formatDetail.visible) {
          this.columns = this.columns.filter(x => x.field !== element.description);
        } else {
          this.updateElementWidth(this.formatDetail.name, this.cashReceiptModels[0].cashReceiptId!);
          this.updateElementStyle(this.formatDetail.name, this.cashReceiptModels[0].cashReceiptId!);
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.cashReceiptModels[0].invoiceCashReceipts!.forEach(detail => {
          if (detail.invoiceCashReceiptId) {
            const id = this.formatDetail.name.includes("footer") ? detail.cashReceiptId : detail.invoiceCashReceiptId;
            this.element = document.getElementById(`${this.formatDetail.name}-${id}`);
            if (this.element) {
              this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
              this.changeAlignment(this.formatDetail.alignment);
              this.changeBold(this.formatDetail.bold);
            }
          }
        });
      }

      this.elementsBody = this.elementsBody.filter(x => x.formatDetailId !== formatDetailId);
      this.elementsBody.push(element);
      const fieldName = element.description;
      if (fieldName && this.idMap[fieldName]) {
        this.idMap[fieldName].printFormat = element.printFormat;
      }
    } else if (isBody2) {
      const element = this.elementsBody2.find(x => x.formatDetailId === formatDetailId);
      if (!element) {
        return;
      }

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;
      element.printFormat = this.formatDetail.printFormat;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;

        if (!this.formatDetail.visible) {
          this.columnsWayToPay = this.columnsWayToPay.filter(x => x.field !== element.description);
        } else {
          this.updateElementWidth(this.formatDetail.name, this.cashReceiptModels[0].cashReceiptId!);
          this.updateElementStyle(this.formatDetail.name, this.cashReceiptModels[0].cashReceiptId!);
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.cashReceiptModels[0].cashReceiptPayments!.forEach(detail => {
          if (detail.cashReceiptPaymentId) {
            const id = this.formatDetail.name.includes("footer") ? detail.cashReceiptId : detail.cashReceiptPaymentId;
            this.element = document.getElementById(`${this.formatDetail.name}-${id}`);
            if (this.element) {
              this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
              this.changeAlignment(this.formatDetail.alignment);
              this.changeBold(this.formatDetail.bold);
            }
          }
        });
      }

      this.elementsBody = this.elementsBody.filter(x => x.formatDetailId !== formatDetailId);
      this.elementsBody.push(element);
      const fieldName = element.description;
      if (fieldName && this.idMapWayToPay[fieldName]) {
        this.idMapWayToPay[fieldName].printFormat = element.printFormat;
      }
    } else {
      this.updateElementStyle(this.formatDetail.name, this.cashReceiptModels[0].cashReceiptId!);

      if (!this.formatDetail.visible) {
        if (this.element) {
          this.element.setAttribute('hidden', '');
        }
      } else {
        this.applyFormatStyles(this.element);
        this.updateLabelText(formatDetailId, this.formatDetail.text!);
        this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== formatDetailId);
        this.listFormatDetailUpdates.push(this.formatDetail);
      }
      const labelElement = this.elementsLabel.find(x => x.name === this.formatDetail.name);
      if (labelElement) {
        labelElement.printFormat = this.formatDetail.printFormat;
        this.elementsLabel = [...this.elementsLabel];
      }

      const bodyElement = this.elementsBody.find(x => x.name === this.formatDetail.name);
      if (bodyElement) {
        bodyElement.printFormat = this.formatDetail.printFormat;
        this.elementsBody = [...this.elementsBody];
      }
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    return new Promise((resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);
      this.cashReceiptModels.forEach(element => {
        this.applyHeaderFooterHeights(element.cashReceiptId, formatModel);
      });
      this.extractFormatDetails(formatModel);
      this.buildDisplayedColumns();
      this.cashReceiptModels.forEach(element => {
        this.applyFormatDetails(formatModel.formatDetails, element);
      });
      setTimeout(async () => {
        this.cashReceiptModels.forEach(element => {
          this.applyColumnStyles(element);
        });
        this.cashReceiptModels.forEach(element => {
          this.applyParagraphStyles(element);
        });
        resolved(true);
      }, 200);
    });
  }

  clickTable(event: any) {
    if (!this.editFormat) {
      return;
    }

    const element = document.getElementById(event.target.id);
    if (!element) {
      return;
    }

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    const bodyElement = this.elementsBody.find(x => x.name === name);

    if (!formatDetail || !bodyElement) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;
    this.newFormatDetail.visible = bodyElement.visible;
    this.newFormatDetail.text = bodyElement.text;
    this.newFormatDetail.orderTable = bodyElement.orderTable;
    this.newFormatDetail.printFormat = bodyElement.printFormat;

    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }
    const fontSize = parseInt(elementStyle.getPropertyValue('font-size').replace('px', ''));
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  decreaseHeight() {
    this.adjustElementSize('height', -this.speed);
  }

  decreaseWidth() {
    this.adjustElementSize('width', -this.speed);
  }


  onColumnReorder(columns: { field: string; header: string; }[]) {
    columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  onColumnReorderWayToPay(columns: { field: string; header: string; }[]) {
    columns.forEach((col, index) => {
      this.elementsBody2.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(x => x.type === 'label');
    this.elementsBody = formatModel.formatDetails
      .filter(x => x.band === 'body' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);
    this.elementsBody2 = formatModel.formatDetails
      .filter(x => x.band === 'body2' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);
  }

  private getBorderStyle(): string {
    if (this.elementStyle.getPropertyValue('border')) {
      if (this.elementStyle.getPropertyValue('border') === '0px none rgb(0, 0, 0)') {
        return 'noborder';
      } else {
        return 'border';
      }
    } else {
      return 'underline';
    }
  }

  getLabelPrintFormat(name: string): string | null {
    const format = this.elementsLabel.find(x => x.name === name)?.printFormat ?? null;
    return format?.trim() ? format : null;
  }

  async getFormatByCompanyAndCode() {
    const promises: any = [];
    if (this.companyId != null && this.companyId != 0) {
      try {
        const response = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId, FormatsEnums.cashReceipt));
        Promise.all(promises).then(async () => {
          await this.chargeFormat(response);
          this.cdr.detectChanges();
          requestAnimationFrame(() => {
            this.finishLoadingPrint.emit(true);
          });
        });
      } catch (error) {
        console.error('Error al obtener el formato por empresa y código.', error);
      }
    }
  }

  async getLogo(enterpriseLogo: string) {
    let blob: Blob | null = null;
    try {
      blob = await firstValueFrom(this.enterpriseService.getEnterpriseLogoAsync(enterpriseLogo));
      if (blob) {
        this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      }
    } catch (error) {
      console.error('Error al obtener el logo de la empresa.', error);
    }
  }

  async getLogoDefault() {
    const logoPath = 'assets/images/icons/logo-empty.png';
    this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(logoPath);
  }

  getPaidValueWayToPay(element: Array<CashReceiptPaymentPrintModel>) {
    return element.map(t => (t.paidValueWayToPay)).reduce((acc, value) => acc + value, 0);
  }

  getPrintCashReceipts() {
    //ordena de forma ascendente las facturas en el recibo de caja
    this.cashReceiptModels.forEach(element => {
      element.invoiceCashReceipts = element.invoiceCashReceipts.sort(
        function (a, b) {
          return a.document > b.document ? 1 : -1;
        });
    });

    this.getFormatByCompanyAndCode();
  }

  private getStylePx(property: string): number {
    return parseFloat(this.elementStyle.getPropertyValue(property).replace('px', '')) || 0;
  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  increaseHeight() {
    this.adjustElementSize('height', this.speed);
  }

  increaseWidth() {
    this.adjustElementSize('width', this.speed);
  }

  moveDown() {
    this.moveElement('top', this.speed, this.bottomPreview, true);
  }

  private moveElement(direction: 'top' | 'left', delta: number, previewLimit: number, isVertical: boolean) {
    if (this.focusText || !this.elementStyle) {
      return;
    }

    const currentValue = this.elementStyle.getPropertyValue(direction);
    let position = parseFloat(currentValue.replace('px', ''));
    position += delta;
    const sizeProp = isVertical ? 'height' : 'width';
    const size = parseFloat(this.elementStyle.getPropertyValue(sizeProp).replace('px', ''));
    if (position < 0) {
      position = 0;
    }
    if (position + size > previewLimit) {
      position = previewLimit - size;
    }
    const percentage = ((position / previewLimit) * 100).toFixed(4);
    this.element.style[direction] = `${percentage}%`;

    this.onClick();
  }

  moveLeft() {
    this.moveElement('left', -this.speed, this.rightPreview, false);
  }

  moveRight() {
    this.moveElement('left', this.speed, this.rightPreview, false);
  }

  moveUp() {
    this.moveElement('top', -this.speed, this.bottomPreview, true);
  }

  onClick() {
    if (!this.editFormat) {
      return;
    }

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;
    this.newFormatDetail.printFormat = formatDetail.printFormat;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold = this.elementStyle.getPropertyValue('font-weight') === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4));
      this.newFormatDetail.top = parseFloat(((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4));
    }

    this.newFormatDetail.width = parseFloat(this.getStylePxValue('width').toFixed(4));
    this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== this.newFormatDetail.formatDetailId);
    this.listFormatDetailUpdates.push(this.newFormatDetail);
  }

  onDragStart() {
    return false;
  }

  onMouseDown(event: any) {
    if (!this.editFormat) {
      return;
    }

    if (this.element) {
      this.element.style.backgroundColor = 'transparent';
    }

    this.mouseDown = true;
    this.id = event.target.id;
    this.element = document.getElementById(this.id);
    if (!this.element) {
      return;
    }

    this.elementStyle = window.getComputedStyle(this.element);
    this.element.style.backgroundColor = '#0d6efd6e';

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) {
      return;
    }

    const relativeElement = document.getElementById(`${formatDetail.band}-${this.cashReceiptModels[0].cashReceiptId}`);
    if (!relativeElement) {
      return;
    }

    const relativeStyle = window.getComputedStyle(relativeElement);

    this.leftPreview = Math.round(relativeElement.offsetLeft - relativeElement.scrollLeft);
    this.topPreview = Math.round(relativeElement.offsetTop - relativeElement.scrollTop);
    this.rightPreview = parseInt(relativeStyle.width.replace('px', ''));
    this.bottomPreview = parseInt(relativeStyle.height.replace('px', ''));

    this.element.style.cursor = 'move';
    const leftPX = event.pageX - this.leftPreview;
    const topPX = event.pageY - this.topPreview;
    this.shiftX = leftPX - this.getStylePx('left');
    this.shiftY = topPX - this.getStylePx('top');
    this.onClick();
  }

  onMouseMove(event: any) {
    if (!this.mouseDown || this.id.includes('foot-')) return;

    this.element.style.position = 'absolute';
    const leftPx = Math.max(0, event.pageX - this.leftPreview - this.shiftX);
    const widthPx = this.getStylePx('width');
    const finalLeft = Math.min(leftPx, this.rightPreview - widthPx);
    const topPx = Math.max(0, event.pageY - this.topPreview - this.shiftY);
    const heightPx = this.getStylePx('height');
    const finalTop = Math.min(topPx, this.bottomPreview - heightPx);

    this.updateElementPosition(finalLeft, finalTop);
    this.onClick();
  }

  onMouseUp() {
    this.mouseDown = false;
  }

  private updateElementWidth(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.width = `${this.formatDetail.width}%`;
  }

  private updateLabelText(formatId: number, text: string) {
    const labelElement = this.elementsLabel.find(x => x.formatDetailId === formatId);
    if (labelElement) {
      labelElement.text = text;
    }
  }

  private updateElementPosition(leftPx: number, topPx: number) {
    const leftPercentage = ((leftPx / this.rightPreview) * 100).toFixed(4);
    const topPercentage = ((topPx / this.bottomPreview) * 100).toFixed(4);
    this.element.style.left = `${leftPercentage}%`;
    this.element.style.top = `${topPercentage}%`;
  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  async updateRangeFormatDetail() {
    this.elementsBody.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });

    this.elementsBody2.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });

    const response = await firstValueFrom(this.formatDetailService.updateRangeFormatDetail(this.listFormatDetailUpdates));
    this.chargeFormat(response);
  }

}
